module.exports = __webpack_public_path__ + "img/white-drop.287fb1ff.svg";